import {
  HYDRATE,
  SET_ANALYTICS_DATE_RANGE,
  SET_ANALYTICS_STATUS,
  SET_ANALYTICS_POSTS,
  SET_ANALYTICS_POSTS_METRICS,
  SET_ANALYTICS_STATIC_DATA,
  SET_ANALYTICS_CHARTS_DATA,
  SET_ANALYTICS_POSTS_ORDER,
  SET_ANALYTICS_POSTS_PAGINATION,
  SET_ANALYTICS_SELECTED_METRICS,
  SET_ANALYTICS_CHART_METRICS,
  SET_ANALYTICS_LOADING,
  CLONE_ANALYTICS_CHART,
  REMOVE_ANALYTICS_CHART,
} from "../_actions/types";
import {
  POSTS_COUNT,
  ENGAGED_USERS,
  REACH,
  POST_REACH,
  PAGE_POST_ENGAGEMENTS,
  IMPRESSIONS,
  FOLLOWER_COUNT,
  RETWEET_COUNT,
  LIKES,
  CLICKS,
} from "../_constants/AnalyticsAccountsMetrics";
import * as SocialTypes from "../_constants/SocialType";

export const defaultSelectedMetrics = {
  [SocialTypes.FACEBOOK_PAGE]: [
    POSTS_COUNT.id,
    ENGAGED_USERS.id,
    POST_REACH.id,
    PAGE_POST_ENGAGEMENTS.id
  ],
  [SocialTypes.INSTAGRAM_BUSINESS]: [
    POSTS_COUNT.id,
    FOLLOWER_COUNT.id,
    IMPRESSIONS.id,
    REACH.id,
  ],
  [SocialTypes.TWITTER_PROFILE]: [
    POSTS_COUNT.id,
    RETWEET_COUNT.id,
  ],
  [SocialTypes.LINKEDIN_COMPANY]: [
    POSTS_COUNT.id,
    CLICKS.id,
    LIKES.id,
    IMPRESSIONS.id,
  ],
}

export const initialState = {
  loading: true,
  status: null,
  dateFrom: null,
  dateTo: null,
  chartsData: null,
  order: "DSC",
  orderBy: "publishedDate",
  defaultSelectedMetrics,
  selectedMetrics: defaultSelectedMetrics, // persisted
  charts: { // persisted
    [SocialTypes.FACEBOOK_PAGE]: [
      {
        id: 1,
        metrics: [POSTS_COUNT.id],
      },
      {
        id: 2,
        metrics: [ENGAGED_USERS.id],
      },
    ],
    [SocialTypes.INSTAGRAM_BUSINESS]: [
      {
        id: 3,
        metrics: [POSTS_COUNT.id],
      },
      {
        id: 4,
        metrics: [FOLLOWER_COUNT.id],
      },
    ],
    [SocialTypes.TWITTER_PROFILE]: [
      {
        id: 5,
        metrics: [POSTS_COUNT.id],
      },
    ],
    [SocialTypes.LINKEDIN_COMPANY]: [
      {
        id: 6,
        metrics: [POSTS_COUNT.id],
      },
    ],
  },
  staticMetricsData: [],
  posts: {
    items: [],
    metrics: [],
    pagination: {
      currentPage: 1,
      itemsPerPage: "10",
      pagesCount: 1,
      hasMore: true,
    },
  },
};

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE:
      return { ...initialState, ...state };

    case SET_ANALYTICS_LOADING: {
      return {
        ...state,
        loading: action.payload,
      }
    }

    case SET_ANALYTICS_STATUS: {
      return {
        ...state,
        status: action.payload,
      }
    }

    case SET_ANALYTICS_DATE_RANGE: {
      return {
        ...state,
        dateFrom: action.payload.from,
        dateTo: action.payload.to,
      }
    }

    case SET_ANALYTICS_CHARTS_DATA: {
      return {
        ...state,
        chartsData: action.payload,
      }
    }

    case SET_ANALYTICS_STATIC_DATA: {
      return {
        ...state,
        staticMetricsData: action.payload,
      }
    }

    case SET_ANALYTICS_SELECTED_METRICS: {
      return {
        ...state,
        selectedMetrics: {
          ...state.selectedMetrics,
          [action.payload.type]: action.payload.metrics,
        }
      }
    }

    case SET_ANALYTICS_CHART_METRICS: {
      const chartIndex = state.charts[action.payload.type].findIndex(chart => chart.id === action.payload.chartId);
      const updatedCharts = [...state.charts[action.payload.type]];

      updatedCharts[chartIndex].metrics = action.payload.metrics;

      return {
        ...state,
        charts: {
          ...state.charts,
          [action.payload.type]: updatedCharts
        },
      }
    }

    case REMOVE_ANALYTICS_CHART: {
      const updatedCharts = [...state.charts[action.payload.type]].filter((chart) => chart.id !== action.payload.chartId);

      return {
        ...state,
        charts: {
          ...state.charts,
          [action.payload.type]: updatedCharts,
        },
      }
    }

    case CLONE_ANALYTICS_CHART: {
      const index = state.charts[action.payload.type].indexOf(action.payload.chart);
      const newChart = {
        ...action.payload.chart,
        id: action.payload.clonedId,
      };
      const updatedCharts = [...state.charts[action.payload.type]];

      updatedCharts.splice(index, 0, newChart);

      return {
        ...state,
        charts: {
          ...state.charts,
          [action.payload.type]: updatedCharts,
        },
      }
    }

    case SET_ANALYTICS_POSTS_PAGINATION: {
      return {
        ...state,
        posts: {
          ...state.posts,
          pagination: {
            ...state.posts.pagination,
            ...action.payload,
          }
        },
      }
    }

    case SET_ANALYTICS_POSTS: {
      return {
        ...state,
        posts: {
          ...state.posts,
          items: action.payload,
        },
      };
    }

    case SET_ANALYTICS_POSTS_METRICS: {
      return {
        ...state,
        posts: {
          ...state.posts,
          metrics: action.payload,
        },
      };
    }

    case SET_ANALYTICS_POSTS_ORDER: {
      return {
        ...state,
        order: action.payload.order,
        orderBy: action.payload.orderBy,
      }
    }

    default:
      return state;
  }
};

export default analyticsReducer;
